<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm8>
        <v-btn
          color="primary"
          @click="create"
          class="mb-4"
          :disabled="!hasCondominioAccess(entity, 'create')"
        >
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.condominio_pessoa.pessoa.id_texto }}</td>
            <td>{{ props.item.porcentagem }}</td>
            <td>{{ props.item.data | formatDate }}</td>
            <td align="center">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'delete')"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  name="condominio_pessoa_id"
                  v-model="editedItem.condominio_pessoa_id"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('condominio_pessoa_id')"
                  :data-vv-as="translate('table.' + entity + '.field.condominio_pessoa_id')"
                  :label="translate('table.' + entity + '.field.condominio_pessoa_id')"
                  :items="translate('value.dynamic_pessoas')"
                  item-text="pessoa.id_texto_porcentagem"
                  item-value="id"
                ></v-autocomplete>

                <v-autocomplete
                  :label="translate('table.' + entity + '.field.condominio_pessoa_id')"
                  v-model="editedItem.condominio_pessoa_id"
                  :items="dynamic_pessoas"
                  item-text="pessoa.id_texto_porcentagem"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <p-money
                  name="porcentagem"
                  label="Porcentagem a ser vendida"
                  v-model="editedItem.porcentagem"
                  :v_validate="'positiveNumber|max_value:100'"
                  custom_preffix=""
                ></p-money>
              </v-flex>
              <v-flex xs12 md3>
                <p-date
                  name="data"
                  :label="translate('table.' + entity + '.field.data')"
                  v-model="editedItem.data"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('data')"
                  :v_validate="'required'"
                  :data_vv_as="translate('table.' + entity + '.field.data')"
                ></p-date>
              </v-flex>
              <v-flex xs12>
                <span class="title" v-if="editedItem.porcentagem > 0">
                  Porcentagem restante: {{ porcentagemRestante.toFixed(15) }}%
                </span>
              </v-flex>
              <v-flex xs12 md8>
                <span class="headline">Distribuições</span>
              </v-flex>
              <v-flex xs12 md4 class="text-xs-right">
                <v-btn color="primary" @click="createSubItem()" class="my-1">
                  {{ this.translate("system.button.add.title") }}
                  <v-icon dark>
                    {{ this.translate("system.button.add.icon") }}
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="headers_items"
                  :items="editedItem.items"
                  class="elevation-1"
                  hide-actions
                  no-results-text="Nenhum registro encontrado"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <v-autocomplete
                        v-model="props.item.condominio_pessoa_id"
                        :items="dynamic_pessoas"
                        item-text="pessoa.id_texto"
                        item-value="id"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <p-money
                        name="porcentagem"
                        v-model="props.item.porcentagem"
                        :v_validate="'positiveNumber|max_value:100'"
                        :custom_precision="15"
                        custom_preffix=""
                      ></p-money>
                    </td>
                    <td align="center">
                      <v-btn icon class="mx-0" @click="deleteSubItem(props.item)">
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  <template slot="footer">
                    <td class="body-2" colspan="1">Total</td>
                    <td class="body-2" colspan="2">{{ getSum().toFixed(15) }}%</td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
table td .custom-height {
  padding-top: 22px;
}

tr td:last-child {
  min-width: 130px;
}
</style>

<script>
import crud from "./../../mixin/crud";
import PDate from "../shared/PDate";
import acl from "./../../mixin/acl";
import Math from "./../../classes/math";
import PMoney from "../shared/PMoney";
import Big from "big.js";

export default {
  components: {
    PDate,
    PMoney,
  },
  mixins: [crud, acl],
  data: () => ({
    entity: "condominio_transacao",
    items: [],
    dynamic_pessoas: [],
    pagination: {
      rowsPerPage: -1,
    },
  }),
  name: "Transacao",
  props: ["condominio_id", "values", "pessoas"],
  created() {
    this.dynamic_pessoas = this.pessoas.map((value) => {
      value.pessoa.id_texto_porcentagem = `${value.pessoa.id_texto} - ${value.porcentagem}%`;
      return value;
    });

    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      items: [],
      porcentagem: 0,
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      items: [],
      porcentagem: 0,
    };
  },
  computed: {
    porcentagemRestante() {
      return this.getSum().minus(this.editedItem.porcentagem || 0);
    },
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.condominio_pessoa_id"),
          value: "condominio_pessoa.pessoa.id_texto",
          width: "55%",
        },
        {
          text: this.translate("table." + this.entity + ".field.porcentagem"),
          value: "porcentagem",
          width: "20%",
        },
        {
          text: this.translate("table." + this.entity + ".field.data"),
          value: "data",
          width: "20%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
    headers_items: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.condominio_pessoa_id"),
          value: "condominio_pessoa.pessoa.id_texto",
          width: "55%",
        },
        {
          text: this.translate("table." + this.entity + ".field.porcentagem"),
          value: "porcentagem",
          width: "20%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  methods: {
    getSum: function () {
      let total = Big(0);
      this.editedItem.items.forEach(function (item) {
        total = total.plus(parseFloat(item.porcentagem || 0));
      });
      return total;
    },
    createSubItem: function () {
      this.editedItem.items.push({
        porcentagem: 0,
        condominio_pessoa_id: "",
      });
    },
    deleteSubItem(item) {
      const index = this.editedItem.items.indexOf(item);
      this.editedItem.items.splice(index, 1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/Transacao.vue